import apiClient from "@/lib/api-client"
import type { SiteSetting, SiteSettingCreateRequest, SiteSettingUpdateRequest, PaginatedResponse } from "@/types/api"

export const commonService = {
  // Site Settings
  getSiteSettings: async (): Promise<SiteSetting[]> => {
    const response = await apiClient.get<PaginatedResponse<SiteSetting>>("/common/site-settings/")
    return response.results
  },

  getSiteSetting: async (key: string): Promise<SiteSetting> => {
    return apiClient.get<SiteSetting>(`/common/site-settings/${key}/`)
  },

  createSiteSetting: async (data: SiteSettingCreateRequest): Promise<SiteSetting> => {
    return apiClient.post<SiteSetting>("/common/site-settings/", data)
  },

  updateSiteSetting: async (key: string, data: SiteSettingUpdateRequest): Promise<SiteSetting> => {
    return apiClient.patch<SiteSetting>(`/common/site-settings/${key}/`, data)
  },

  deleteSiteSetting: async (key: string): Promise<void> => {
    await apiClient.delete(`/common/site-settings/${key}/`)
  },
}
